module.exports = __webpack_public_path__ + "static/media/bashir.1631a1e7.jpg";